import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_camiones/Asignar_camiones/Asignar_camiones.html?vue&type=template&id=7b367546&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_camiones/Asignar_camiones/Asignar_camiones.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_camiones/Asignar_camiones/Asignar_camiones.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_camiones/Asignar_camiones/Asignar_camiones.css?vue&type=style&index=0&id=7b367546&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b367546",
  null
  
)

export default component.exports